import {
    GET_REPORT_DATA_SUCCESS,
    GET_REPORT_DATA_FAILURE,
  } from "./actions";
  
  const initialState = {
    reportData: null,
    error: null,
  };
  
  const EmployeeEarningsReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_REPORT_DATA_SUCCESS:
        return {
          ...state,
          reportData: action.payload.data,
          error: null,
        };
      case GET_REPORT_DATA_FAILURE:
        return {
          ...state,
          reportData: null,
          error: action.payload.error,
        };
      // Add other cases for different actions if needed
  
      default:
        return state;
    }
  };
  
  export default EmployeeEarningsReducer;
  